<template>
    <v-panel
        v-model="currentPanelOpen"
        class="img-cropper-panel"
        :title="panelTitle"
        :width="panelWidth"
        :max-height="panelHeight"
        :min-height="panelHeight"
        :mask-closable="false"
        @close="handleCancel"
    >
        <div class="img-cropper-panel-bd">
            <v-image-cropper
                v-model="currentValue"
                :kind="kind"
                :width="width"
                :height="height"
                :ratio="ratio"
                :keep-ratio="keepRatio"
                :src="src"
            ></v-image-cropper>
        </div>
        <div class="img-cropper-panel-ft">
            <v-button
                class="img-cropper-panel-ft__confirm"
                kind="primary"
                size="large"
                :disabled="isCropping"
                :loading="isCropping"
                @click="handleConfirm"
            >
                确定
            </v-button>
            <v-button class="img-cropper-panel-ft__cancel" size="large" @click="handleCancel">取消</v-button>
        </div>
    </v-panel>
</template>

<script>
import { ImageCropper } from 'vhtml-ui';

export default {
    props: {
        panelTitle: {
            type: String,
            default: '图片裁切'
        },
        panelWidth: {
            type: Number,
            default: 630
        },
        panelHeight: {
            type: Number,
            default: 610
        },
        panelOpen: {
            type: Boolean,
            default: false
        },
        cropperScale: {
            type: Number,
            default: 1
        },
        cropperUrl: {
            type: String,
            default: '/mp/imgCommon/crop?type=crop'
        },
        ...ImageCropper.props
    },

    data() {
        return {
            currentPanelOpen: this.panelOpen,
            currentValue: null,

            isCropping: false
        };
    },

    watch: {
        panelOpen(nextValue) {
            this.currentPanelOpen = nextValue;
        }
    },

    methods: {
        handleConfirm() {
            this.isCropping = true;

            const { src, width, height, cropWidth, cropHeight, scale, cropX, cropY, rotate } = this.currentValue;

            this.$ajax
                .post(this.cropperUrl, {
                    src,
                    width,
                    height,
                    rotate,
                    cropWidth: cropWidth * this.cropperScale,
                    cropHeight: cropHeight * this.cropperScale,
                    originX: parseInt(cropX / scale, 10),
                    originY: parseInt(cropY / scale, 10),
                    originWidth: parseInt(cropWidth / scale, 10),
                    originHeight: parseInt(cropHeight / scale, 10)
                })
                .then(cropData => {
                    if (cropData && +cropData.r === 0) {
                        this.currentPanelOpen = false;
                        this.$emit('confirm', cropData.data.url);
                    } else {
                        this.$message.error((cropData && cropData.message) || '图片裁切失败');
                    }
                    this.isCropping = false;
                })
                .catch(error => {
                    this.$message.error(error.msg || '图片裁切失败');
                    this.isCropping = false;
                });
        },

        handleCancel() {
            this.currentPanelOpen = false;
            this.$emit('cancel');
        }
    }
};
</script>

<style lang="less">
.img-cropper-panel {
    &-bd {
        font-size: 0;
        line-height: 0;

        .v-image-cropper {
            position: relative;

            &__toolbar {
                display: none;
            }
        }
    }

    &-ft {
        margin-top: 30px;

        &__cancel {
            margin-left: 20px;
        }
    }
}
</style>
